import * as React from "react";
import { League } from "../League";
import { Team } from "../Team";
export const TeamsWrapper = (props) => React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__names`, "data-uat": `div-ev-list-${props.componentPrefix}-names` },
    React.createElement(League, { details: props.details, componentPrefix: props.componentPrefix }),
    React.createElement(Team, { event: props.details.event, onServe: "1", componentPrefix: props.componentPrefix }),
    React.createElement(Team, { event: props.details.event, onServe: "2", componentPrefix: props.componentPrefix }));
//# sourceMappingURL=TeamsWrapper.js.map